import { render, staticRenderFns } from "./importFreightQuotation.vue?vue&type=template&id=5c1626b3&scoped=true"
import script from "./importFreightQuotation.vue?vue&type=script&lang=js"
export * from "./importFreightQuotation.vue?vue&type=script&lang=js"
import style0 from "./importFreightQuotation.vue?vue&type=style&index=0&id=5c1626b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1626b3",
  null
  
)

export default component.exports